import React, { useContext, useState } from 'react';

import { Avatar } from '@mui/material';
import { useTranslation } from 'react-i18next';

import StyledButtonNE from '../../../../../shared/components/StyledButtonNE/StyledButtonNE';
import ToastNE from '../../../../../shared/components/ToastNE/ToastNE';
import { TABLET_SCREEN_SIZE } from '../../../../../shared/constants/constants';
import { DEFAULT_TOAST_DATA } from '../../../../../shared/constants/toast';
import { CompanyContext } from '../../../../../shared/context/company/companyContext';
import useWindowSize from '../../../../../shared/hooks/useWindowSize/useWindowSize';
import { IToast } from '../../../../../shared/interfaces/toast';
import { TRANSLATIONS_SETTINGS } from '../../../../../shared/translations/settings';
import { getInitialsLetters } from '../../../../../shared/utils/utils';
import BusinessDataChangeModal from '../BusinessDataChangeModal/BusinessDataChangeModal';

import './EditHoldingCard.scss';

const EditHoldingCard = () => {
  const [changeHoldingModalOpen, setChangeHoldingModalOpen] = useState(false);
  const [changeHoldingToast, setChangeHoldingToast] = useState(false);
  const [toastData, setToastData] = useState<IToast>(DEFAULT_TOAST_DATA);

  const { holding } = useContext(CompanyContext);

  const { width } = useWindowSize();
  const disableEdit = width <= TABLET_SCREEN_SIZE;

  const { t } = useTranslation();

  const openChangeBusinessDataModal = () => {
    setChangeHoldingModalOpen(!disableEdit);
  };

  const handleClosedModal = (toastData?: IToast) => {
    if (toastData) {
      setToastData(toastData);
      setChangeHoldingToast(true);
    }
    setChangeHoldingModalOpen(false);
  };

  const handleCloseToast = () => {
    setChangeHoldingToast(false);
  };

  return (
    <div className="settings-organization-ne-card">
      <div className="edit-holding-ne-container">
        <div className="title">{t(TRANSLATIONS_SETTINGS.businessData.holding)}</div>
        <div className="edit-holding">
          <Avatar className="holding-edit-avatar" style={{ backgroundImage: `url("${holding.image}")` }}>
            {!holding.image && getInitialsLetters(holding.name, ' ')}
          </Avatar>
          {holding.name}
          <StyledButtonNE
            buttonType="secondary"
            buttonSize="sm"
            classes="edit-holding-button"
            action={openChangeBusinessDataModal}
          >
            {t(TRANSLATIONS_SETTINGS.businessData.edit)}
          </StyledButtonNE>
        </div>
      </div>

      {changeHoldingModalOpen && (
        <BusinessDataChangeModal
          isModalOpen={changeHoldingModalOpen}
          handleCloseModal={handleClosedModal}
          id={holding.id}
          name={holding.name}
          isHolding={true}
        />
      )}
      <ToastNE
        title={t(toastData.title)}
        description={t(toastData.description)}
        icon={toastData.icon}
        open={changeHoldingToast}
        button={toastData.button}
        buttonText={t(toastData.buttonText)}
        buttonAction={handleCloseToast}
        handleClose={handleCloseToast}
      />
    </div>
  );
};

export default EditHoldingCard;
